import { createFileRoute } from '@tanstack/react-router'
import { EmptyState } from '@/shared/ui/empty-state'

export const Route = createFileRoute('/scenarios/')({
  component: () => (
    <EmptyState
      icon="pen"
      title="Выбери сценарий"
      description="Слева — каталог сценариев разговора"
    />
  ),
})
